import { useAccount } from "context/AccountContext";
import Trans from "features/translation/components/Trans";
import Button from "components/ui/Button/Button";
import { useDialog } from "context/DialogContext";
import ProfileCreateUpdate from "pages/Profile/ProfileCreateUpdate";

const CheckProfileVisible = ({ children }) => {
  const { profile } = useAccount();
  const { showDialog, hideDialog } = useDialog();

  const profileHidden = profile?.field_profile_hide_profile?.value === '1';
  const profileIncomplete = profile?.field_profile_completed?.value !== '1';

  return (
    <>
      {
        profileHidden || profileIncomplete
          ?
          <>
            <h3>
              { profileIncomplete ? <Trans text={ `Uw profiel is nog niet compleet!` }/> : <Trans text={ `Uw profiel is onzichtbaar!` }/> }
            </h3>
            <p>
              {
                profileIncomplete
                  ?
                  <Trans
                    text={ `U kunt nog geen berichten sturen, prikbordberichten plaatsen of reageren omdat uw profiel nog niet compleet is.` }/>
                  :
                  <Trans
                    text={ `U kunt geen berichten sturen, prikbordberichten plaatsen of reageren omdat uw profiel onzichtbaar is voor andere leden.` }/>
              }
            </p>
            <div className={ `dialog__buttons` }>
              <Button onClick={ () => hideDialog() }>Annuleren</Button>
              <Button variant={ `secondary` } onClick={ () => showDialog(<ProfileCreateUpdate />) }>Profiel aanpassen</Button>
            </div>
          </>
          :
          children
      }
    </>
  )
}

export default CheckProfileVisible;
